import { connect } from 'react-redux'
import ProductItem from './view'

export default connect(null, {})(ProductItem)
